export default __webpack_public_path__ + "static/media/5.961aa8f4.jpg";